import React from 'react'
import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
import {PersistGate} from 'redux-persist/integration/react'
import {Provider} from 'react-redux'
import * as _redux from './setup'
import store, {persistor} from './setup/redux/Store'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'

// Apps
import {App} from './app/App'
import { SmallNationProvider } from './smallnation/i18n/SmallNationProvider'

import './smallnation/assets/sass/style.scss'
import './smallnation/assets/sass/style.react.scss'

const {PUBLIC_URL} = process.env



_redux.setupAxios(axios, store)

Chart.register(...registerables)

ReactDOM.render(
  <SmallNationProvider>
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <App basename={""} />
      </PersistGate>
    </Provider>
  </SmallNationProvider>,
  document.getElementById('root')
)
